module.exports = __webpack_public_path__ + "img/CS-ECONew-Assembly.3fbf03d9.jpg";